"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hero = void 0;
var _react = _interopRequireDefault(require("react"));
require("../cdn.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Hero = exports.Hero = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    tag = "h1",
    title,
    text = "",
    image,
    alt = "",
    index = false,
    children,
    breadcrumbs = [],
    background = "teal-10",
    className = ""
  } = _ref;
  const Tag = tag;
  if (index) {
    return /*#__PURE__*/_react.default.createElement("section", {
      className: ["index-hero", ...className.split(" ")].filter(v => !!v).join(" "),
      ref: ref
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "flex-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "left"
    }, /*#__PURE__*/_react.default.createElement(Tag, {
      className: "hero-text"
    }, title)), /*#__PURE__*/_react.default.createElement("figure", {
      className: "right"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: image || undefined,
      alt: alt
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "container"
    }, children));
  }
  const Breadcrumbs = () => {
    if (!breadcrumbs || breadcrumbs.length === 0) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "breadcrumbs"
    }, breadcrumbs.map((breadcrumb, i) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: i
    }, i < breadcrumbs.length - 1 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("a", {
      href: breadcrumb.href
    }, breadcrumb.value), /*#__PURE__*/_react.default.createElement("i", {
      className: "fa-regular fa-chevron-right"
    })) : /*#__PURE__*/_react.default.createElement("span", {
      className: "current"
    }, breadcrumb.value))));
  };
  return /*#__PURE__*/_react.default.createElement("section", {
    className: [image === null || image === undefined ? "center-hero" : "hero", (image === null || image === undefined) && background ? "bg-".concat(background) : "bg-teal-10", ...className.split(" ")].filter(v => !!v).join(" ")
  }, image === null || image === undefined ? /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement(Breadcrumbs, null), /*#__PURE__*/_react.default.createElement("div", {
    className: "hero-text"
  }, /*#__PURE__*/_react.default.createElement(Tag, null, title), text && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("p", {
    className: "fs-h3"
  }, text)))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "left"
  }, /*#__PURE__*/_react.default.createElement(Breadcrumbs, null), /*#__PURE__*/_react.default.createElement("div", {
    className: "hero-text"
  }, /*#__PURE__*/_react.default.createElement(Tag, null, title), text && /*#__PURE__*/_react.default.createElement("p", {
    className: "fs-h3"
  }, text))), /*#__PURE__*/_react.default.createElement("figure", {
    className: "right"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: image,
    alt: alt
  }))));
});